import { Component, OnInit, ViewChild } from '@angular/core';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { ToastrService } from 'ngx-toastr';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CARRIER_TYPE_ACTIONS } from 'app/shared/actions/actions.constants';
import { Router } from '@angular/router';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
@Component({
  selector: 'app-list-carrier-type',
  templateUrl: './list-carrier-type.component.html',
  styleUrls: ['./list-carrier-type.component.scss']
})
export class ListCarrierTypeComponent implements OnInit {

  cTypes: any = [];
  isRemove = false;
  removeRef: any;  
  lblHeading = '';
  message = "Loading Carrier Type...";

  popoverTitle = 'Delete Carrier Type';
  popoverMessage = 'Are you sure you want to delete Carrier Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
editCarrierTypeId:any
  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;
  @ViewChild('content') modal: NgbModal;
  closeResult:string = '';
  selectcarriertype: any = null;
  selectedIndex: number;
  constructor(private carrierTypeService: CarrierTypeService, private modalService:NgbModal,
     private utility: UtilityServiceService,private toastr: ToastrService, private toastService:ToastNotificationService,
     private router:Router) { }

  ngOnInit() {
    this.onChangeHeading();
    this.reload(); 
  }

  reload() {
    this.isLoading = true;
    this.utility.page = 1;
    this.carrierTypeService.getAll().subscribe(result => {
      this.cTypes = result;
      this.utility.onSort(1);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
    
  }

  onDelete(id: any) {
    this.carrierTypeService.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Carrier Type', message: `Carrier Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastService.success(`Carrier Type ${this.removeRef.code} deleted.`,'Delete Carrier Type');

      if (result != null) {
        this.onNo();
        this.reload();
        this.modalService.dismissAll();
      }
      this.onChangeHeading();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Carrier Type', message: `Carrier Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastService.error(`Carrier Type ${this.removeRef.code} was not deleted.`,'Delete Carrier Type');

    });
  }

  onSort() {

  }

  onConfirm(doc: any, content) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Carrier Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeading(false);
    // this.isRemove = true;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {

        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeading();
  }


  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Carrier Types' : 'Delete Carrier Type';
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  CheckedCarrier(ev: any,optionalVal, res,index) { // Angular 13
    this.editCarrierTypeId=res.id
    this.selectedIndex = ev.target.checked ? index : undefined; 
    if(ev.target.checked){
      this.selectcarriertype = res;

    }else{
      this.selectcarriertype = null;
    }

	}
  doCarrierAction(event:any) {
    if(event.value ==CARRIER_TYPE_ACTIONS.EditCarrierTypes) {
     (this.selectcarriertype == null) ? this.toastService.error('Please select the carrier type first!',''):this.router.navigate(['/carrier/type/edit',this.editCarrierTypeId]);;
      
    } else if(event.value ==CARRIER_TYPE_ACTIONS.AddCarrierType){
      this.router.navigate(['/carrier/type/add']);
    }
    else {
      if(event.value = CARRIER_TYPE_ACTIONS.DeleteCarrierTypes) {
        (this.selectcarriertype == null) ? this.toastService.error('Please select the carrier type first!',''): this.onConfirm(this.selectcarriertype,this.modal);
      }
    }
  }
  

}
